import Component from '@glimmer/component';
import { action } from '@ember/object';

import AccountApi from 'mewe/api/account-api';
import CurrentUserStore from 'mewe/stores/current-user-store';
import FunctionalUtils from 'mewe/shared/functional-utils';
import MiscellaneousUtils from 'mewe/utils/miscellaneous-utils';
import storage from 'mewe/shared/storage';
let { isDefined } = MiscellaneousUtils;

export default class MwFtue extends Component {

  constructor() {
    super(...arguments);
    this.getInitialParams();
  }

  getInitialParams() {
    // no data from parent component so check storage (page refresh ocurred)
    let ftueUnconfirmedUser = storage.get(storage.keys.ftueUnconfirmedUser);
    try {
      ftueUnconfirmedUser = JSON.parse(ftueUnconfirmedUser);
    } catch (e) {}

    if (isDefined(ftueUnconfirmedUser)) {
      this.userData = ftueUnconfirmedUser;
    } else {
      let userFromStore = CurrentUserStore.getState();
      if (userFromStore?.id) {
        this.userData = userFromStore;
      } else {
        // no user data for FTUE so go to homepage
        return window.location.href = '/';
      }
    }

    // registered with phone no (sms verification is assumed if user is in ftue) or confirmed email with contacts import
    if (this.userData?.tmpPhoneId) {
      window.location = `/`;
    } else {
      AccountApi.getCurrentUser()
        .then((data) => {
          if (!data.unvalidated) {
            CurrentUserStore.send('handle', data, true);
            window.location.href = '/';
          }
        });
    }
  }

  @action
  resendEmail(retries) {
    let retriesLeft;

    if (typeof retries !== 'undefined') {
      retriesLeft = Number(retries);
    } else {
      retriesLeft = 3;
    }

    const doneCallback = () => {
      FunctionalUtils.info(
        __('A new validation email has been sent to {email}', {
          email: this.userData.email,
        })
      );
    };

    if (retriesLeft > -1 && this.userData.email) {
      AccountApi.resendConfirmationLink(this.userData.email)
        .then(doneCallback)
        .catch(() => {
          if (retriesLeft - 1 > -1) {
            this.resendEmail((retriesLeft - 1).toString());
          } else {
            FunctionalUtils.showDefaultErrorMessage();
          }
        });
    }
  }

}
